import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import DatePicker from 'components/final-form/DatePicker';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import PraxFormLabelSpan from 'components/layout/PraxFormLabelSpan';
import PxGrid from 'components/layout/PxGrid';
import moment from 'moment';
import React from 'react';
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Header, Segment } from 'semantic-ui-react';
import axios from 'services/http';
import { getBillXmlRequestNotifications } from 'services/mediDataServices';
import styled from 'styled-components';
import { MediDataNotificationsDto } from 'ts-types/api.types';

const StyledForm = styled.form`
  & .ui.grid > .row {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  & .ui.grid > .row:first-child {
    padding-bottom: 1rem !important;
  }

  & .ui.grid {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

const SearchSegment = styled(Segment)`

  &.ui.segment, .ui.segments &.segment {
    padding-left: 0;
    padding-bottom: 0;
  }
`;

interface Props extends MessageSourceProps, AuthConsumerRenderProps {
  onFilterNotificationData: (notificationData: Partial<MediDataNotificationsDto>) => void,
  onNotificationLoadingChange: (notificationsLoading: boolean) => void
}

interface MediDataInvoiceNotificationRequest {
  fromDate: string,
  toDate: string
}

const MediDataNotificationsSearchView = (props: Props) => {

  const {onFilterNotificationData, onNotificationLoadingChange, getMessage} = props;

  const cancelTokenSource: CancelTokenSource = axios.CancelToken.source();

  const initialValues = (): MediDataInvoiceNotificationRequest => {
    return {
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD")
    }
  };

  const handleSubmit = (values: Partial<MediDataInvoiceNotificationRequest>) => {

    onNotificationLoadingChange(true);

    if (values.fromDate && values.toDate) {
      let mandateId = props.currentUser!.userConfig.mandateId;
      getBillXmlRequestNotifications(mandateId, values.fromDate, values.toDate, cancelTokenSource)
          .then(response => {
            onFilterNotificationData(response)
          })
          .finally(() => {
            onNotificationLoadingChange(false)
          })
    }
  };

  const renderForm = ({handleSubmit, values}: FormRenderProps): React.ReactNode => {

    return (
        <StyledForm
            onSubmit={handleSubmit}
        >
          <FormContainer>
            <FormContent>
              <PxGrid>
                <Grid.Row>
                  <Grid.Column width={13} verticalAlign="middle">
                    <Header>{getMessage("searchOptions")}</Header>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} verticalAlign="middle">
                    <PraxFormLabelSpan htmlFor="fromDate">{getMessage('from')}</PraxFormLabelSpan>
                    <Field
                        style={{width: '7rem'}}
                        name="fromDate"
                        component={DatePicker}
                        emptyDateInput
                        fluid
                    />
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle">
                    <PraxFormLabelSpan htmlFor="toDate">{getMessage('to')}</PraxFormLabelSpan>
                    <Field
                        style={{width: '7rem'}}
                        name="toDate"
                        component={DatePicker}
                        emptyDateInput
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={1} verticalAlign="bottom">
                    <Button type="submit" primary size="tiny" compact>{getMessage("search")}</Button>
                  </Grid.Column>
                </Grid.Row>
              </PxGrid>
            </FormContent>
          </FormContainer>
        </StyledForm>
    )
  }

  return (
      <SearchSegment>
        <FinalForm
            onSubmit={handleSubmit}
            initialValues={initialValues()}
            render={renderForm}
        />
      </SearchSegment>
  );
}

export default withMessages(withAuthContext(MediDataNotificationsSearchView));
